import { render, staticRenderFns } from "./SysMessageTemplateList.vue?vue&type=template&id=02d1d4e0&scoped=true"
import script from "./SysMessageTemplateList.vue?vue&type=script&lang=js"
export * from "./SysMessageTemplateList.vue?vue&type=script&lang=js"
import style0 from "./SysMessageTemplateList.vue?vue&type=style&index=0&id=02d1d4e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d1d4e0",
  null
  
)

export default component.exports